import React from 'react';
import PropTypes from 'prop-types';
import { useShallow } from 'zustand/react/shallow';

import { VIEW_MODE } from '../constants';
import AddPhotosDevice from '../common/add-photos-device';
import { DuplicatePhotosList } from '../common/duplicate-detection/duplicate-photos-list';
import PhotosGrid from './photos-grid';
import DebugView from '../common/debug-view';
import { useAdvancedEditorStore } from '../stores/use-advanced-editor-store';
import Spinner from '../../_utils/spinner';

const MainView = ({
  orderedPhotosLength,
  addPhotos,
  currentView,
  totalDuplicatesCount,
  photosWithDuplicates,
  sizesByFinish,
  editingDisabled,
  availableSizes,
  deliveryOption,
  viewingSizeKey,
  orderedPhotos,
  invalidDeliveryOptionSelected,
  currentlyLoading,
}) => {
  const { openEditor: openAdvancedEditPopup } = useAdvancedEditorStore(
    useShallow((state) => ({
      openEditor: state.openEditor,
    })),
  );

  if (!orderedPhotosLength && !currentlyLoading) {
    return <AddPhotosDevice onClick={addPhotos} />;
  }

  if (currentView === VIEW_MODE.DEBUG) {
    return <DebugView />;
  }

  if (currentView === VIEW_MODE.DUPLICATES) {
    return (
      <DuplicatePhotosList
        totalDuplicatesCount={totalDuplicatesCount}
        photosWithDuplicates={photosWithDuplicates}
        disabled={editingDisabled}
      />
    );
  }

  return (
    <>
      {currentlyLoading && (
        <section className="d-flex flex-column list-item list-item--uploading">
          <div className="list-item__size row">
            <div className="col-6 list-item__size__photo">
              <div className="photo pending">
                <Spinner />
              </div>
            </div>
          </div>
        </section>
      )}
      <PhotosGrid
        availableSizes={availableSizes}
        deliveryOption={deliveryOption}
        onAdvancedEditPhoto={(clientUuid) =>
          openAdvancedEditPopup({ clientUuid })
        }
        sizes={sizesByFinish}
        viewingSizeKey={viewingSizeKey}
        orderedPhotos={orderedPhotos}
        invalidDeliveryOptionSelected={invalidDeliveryOptionSelected}
        handleAddPhotos={addPhotos}
      />
    </>
  );
};

MainView.propTypes = {
  orderedPhotosLength: PropTypes.number,
  addPhotos: PropTypes.func.isRequired,
  currentView: PropTypes.string,
  totalDuplicatesCount: PropTypes.number,
  photosWithDuplicates: PropTypes.array,
  sizesByFinish: PropTypes.array,
  editingDisabled: PropTypes.bool,
  availableSizes: PropTypes.array,
  deliveryOption: PropTypes.object,
  viewingSizeKey: PropTypes.string,
  orderedPhotos: PropTypes.array,
  invalidDeliveryOptionSelected: PropTypes.bool,
  currentlyLoading: PropTypes.object,
};

export default MainView;
